import store from '../store';

export function updateNoIndexTag(to) {
  const noindexTag = document.querySelector('meta[name="robots"]');
  const forceNoIndex = store.state.companyModule?.forceNoIndex === true;
  const shouldNoIndex = to.meta.noindex || forceNoIndex;

  if (shouldNoIndex) {
    if (!noindexTag) {
      const tag = document.createElement('meta');
      tag.setAttribute('name', 'robots');
      tag.setAttribute('content', 'noindex');
      document.head.appendChild(tag);
    } else {
      noindexTag.setAttribute('content', 'noindex');
    }
  } else if (noindexTag) {
    noindexTag.remove();
  }

  let baseUrl = window.location.origin;
  if (!baseUrl) {
    return;
  }

  baseUrl = baseUrl.replace(/\/$/, '');
  const absRouteUrl = baseUrl + to.path;
  const canonicalTag = document.querySelector('link[rel="canonical"]');

  if (!shouldNoIndex) {
    if (canonicalTag) {
      canonicalTag.setAttribute('href', absRouteUrl);
    } else {
      const tag = document.createElement('link');
      tag.setAttribute('rel', 'canonical');
      tag.setAttribute('href', absRouteUrl);
      document.head.appendChild(tag);
    }
  } else if (canonicalTag) {
    canonicalTag.remove();
  }
}
